const canvas = document.getElementById('snowCanvas');
const ctx = canvas.getContext('2d');
 
let width = canvas.width = window.innerWidth;
let height = canvas.height = window.innerHeight;

// Layer definitions: back, middle, front
const layers = [
  { count: 50, minSize: 5, maxSize: 8, minSpeed: 0.5, maxSpeed: 1.5, minOpacity: 0.2, maxOpacity: 0.5 },   // back
  { count: 40, minSize: 8, maxSize: 12, minSpeed: 1, maxSpeed: 2, minOpacity: 0.5, maxOpacity: 0.7 },     // middle
  { count: 50, minSize: 12, maxSize: 15, minSpeed: 1.5, maxSpeed: 3, minOpacity: 0.7, maxOpacity: 1 }     // front
];

const snowflakes = [];

// Initialize all layers
for (let layer of layers) {
  for (let i = 0; i < layer.count; i++) {
    snowflakes.push({
      x: Math.random() * width,
      y: Math.random() * height,
      size: Math.random() * (layer.maxSize - layer.minSize) + layer.minSize,
      speed: Math.random() * (layer.maxSpeed - layer.minSpeed) + layer.minSpeed,
      opacity: Math.random() * (layer.maxOpacity - layer.minOpacity) + layer.minOpacity
    });
  }
}

function drawSnowflakes() {
  ctx.clearRect(0, 0, width, height);

  for (let flake of snowflakes) {
    ctx.globalAlpha = flake.opacity;
    ctx.font = `${flake.size}px sans-serif`;
    ctx.fillStyle = '#d8ecff';
    ctx.fillText('❄︎', flake.x, flake.y);

    flake.y += flake.speed; // vertical fall

    // Reset when off bottom
    if (flake.y > height) {
      flake.y = -flake.size;
      flake.x = Math.random() * width;
      // Keep original size, speed, opacity range depending on its layer
    }
  }

  ctx.globalAlpha = 1; // reset alpha
  requestAnimationFrame(drawSnowflakes);
}

drawSnowflakes();

// Responsive canvas
window.addEventListener('resize', () => {
  width = canvas.width = window.innerWidth;
  height = canvas.height = window.innerHeight;
});